<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Catálogo de Itens</h1>
                                    <p class="modern-subtitle">Configure os itens cadastrados para seus processos!</p>
                                </div>
                            </div>
                        </div>
                    </div><!-- modern-header -->
                    <div v-if="bloqueadoImportacao" class="importacao-em-andamento-container">
                        <div class="importacao-em-andamento-card">
                            <div class="importacao-em-andamento-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M8 3a5 5 0 1 0 4.546 7.083.5.5 0 0 1 .908.418A6 6 0 1 1 8 2v1z" />
                                    <path d="M8 0a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 8 0z" />
                                </svg>
                            </div>
                            <h2>Importação em andamento</h2>
                            <p>{{ mensagemBloqueio }}</p>
                            <div class="importacao-em-andamento-actions">
                                <button class="modern-btn modern-btn-primary" @click="recarregarStatusImportacao" :disabled="carregandoStatusImportacao">
                                    <span v-if="!carregandoStatusImportacao">Recarregar status</span>
                                    <span v-else>Verificando...</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="table-container">
                        <div class="table-wrapper">
                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <button v-if="!modoExclusao" @click="abrirModalInclusao" class="modern-btn modern-btn-primary" :disabled="bloqueadoImportacao">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    Novo Item
                                </button>
                                <button v-if="!modoExclusao" @click="abrirModalImportacao" class="modern-btn modern-btn-success" :disabled="bloqueadoImportacao">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    Importar CatMat/CatSer
                                </button>

                                <div class="search-box">
                                    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>
                                    <input v-model="pagFilter" type="text" class="modern-search-input" placeholder="Buscar" :disabled="bloqueadoImportacao">
                                </div>
                                <template v-if="modoExclusao">
                                    <span class="exclusao-contador">{{ qtdSelecionados.toLocaleString('pt-BR') }} {{ qtdSelecionados === 1 ? 'selecionado' : 'selecionados' }} / {{ limiteExclusaoFormatado }}</span>
                                    <button @click="excluirSelecionados"
                                            class="modern-btn modern-btn-danger"
                                            title="Excluir itens selecionados"
                                            :disabled="qtdSelecionados === 0 || excluindoItens">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                        Excluir
                                    </button>
                                    <button @click="cancelarModoExclusao" class="modern-btn modern-btn-secondary" :disabled="excluindoItens">
                                        Cancelar
                                    </button>
                                </template>
                                <button v-if="!modoExclusao" @click="abrirModalImportacaoExcel" class="modern-btn modern-btn-signature" :disabled="bloqueadoImportacao">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    Importar Excel
                                </button>
                            </div> <!-- custom-table-header -->
                            <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <!-- Header -->
                                <thead>
                                    <tr>
                                        <th v-if="modoExclusao" class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper selecao-wrapper">
                                                <input type="checkbox"
                                                       class="selecao-checkbox"
                                                       title="Marcar/desmarcar esta página"
                                                       :checked="paginaTodaSelecionada"
                                                       :disabled="itens.length === 0 || selecaoBloqueada"
                                                       @change="alternarSelecaoPagina($event.target.checked)">
                                                <button type="button" class="selecao-menu-toggle" title="Opções de seleção" :disabled="selecaoBloqueada" @click.stop="menuSelecaoAberto = !menuSelecaoAberto">▾</button>
                                                <div v-if="menuSelecaoAberto && !selecaoBloqueada" class="selecao-menu" @click.stop>
                                                    <button type="button" @click="marcarPaginaAtual">Marcar esta página</button>
                                                    <button type="button" @click="marcarTodos(false)">Marcar todo o catálogo</button>
                                                    <button v-if="buscaCarregadaAtiva" type="button" @click="marcarTodos(true)">Marcar resultados da busca</button>
                                                    <button type="button" @click="desmarcarTodos">Desmarcar todos</button>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Código</span>
                                            </div>
                                        </th>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Referência</span>
                                            </div>
                                        </th>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 30%;">
                                            <div class="text-left">
                                                <span class="th-title">Nome Item</span>
                                            </div>
                                        </th>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Tipo de Item</span>
                                            </div>
                                        </th>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Origem do Item</span>
                                            </div>
                                        </th>
                                        <th v-if="!modoExclusao" scope="col" class="text-center bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Ações</th>
                                    </tr>
                                </thead>
                                <!-- Body -->
                                <tbody>
                                    <tr v-if="carregandoItens">
                                        <td colspan="6" class="empty-state">
                                            <div class="empty-content">
                                                <svg class="grid-spinner" viewBox="0 0 50 50" aria-label="Carregando">
                                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" />
                                                </svg>
                                                <h3 class="empty-title">Carregando itens</h3>
                                                <p class="empty-description">Aguarde enquanto os registros são consultados.</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <template v-else>
                                        <tr v-for="item in itens" :key="item.idItem">
                                            <td v-if="modoExclusao" data-label="Selecionar" class="text-center">
                                                <input type="checkbox"
                                                       class="selecao-checkbox"
                                                       :checked="!!idsSelecionados[item.idItem]"
                                                       :disabled="selecaoBloqueada"
                                                       @change="onCheckboxItem(item.idItem, $event)">
                                            </td>
                                            <td data-label="Código" class="text-center">
                                                {{ item.cdItem }}
                                            </td>
                                            <td data-label="Referência" class="text-center">
                                                {{ item.cdReferencia }}
                                            </td>
                                            <td data-label="Nome Item" class="text-left">
                                                {{ item.nmItem }}
                                            </td>
                                            <td data-label="Tipo de Item" class="text-center">
                                                {{ item.nmTpItem }}
                                            </td>
                                            <td data-label="Origem do Item" class="text-center">
                                                {{ item.nmTipoItem }}
                                            </td>
                                            <td v-if="!modoExclusao" data-label="Ações" class="text-center action-cell" style="white-space: nowrap; width: 1%;">
                                                <div class="action-buttons">
                                                    <button @click="abrirDetalhes(item.idItem)"
                                                            class="action-btn action-btn-view"
                                                            title="Ver Detalhes"
                                                            :disabled="bloqueadoImportacao">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                        </svg>
                                                        <span class="action-text">Detalhes</span>
                                                    </button>
                                                    <button @click="entrarModoExclusao(item.idItem)"
                                                            class="action-btn action-btn-delete"
                                                            title="Excluir"
                                                            :disabled="bloqueadoImportacao">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="itens.length === 0">
                                            <td colspan="6" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h3 class="empty-title">Nenhum item encontrado</h3>
                                                    <p class="empty-description">Crie ou importe seu primeiro item voltado aos processos inteligentes!</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                            <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                <div class="pagination-controls flex items-center">
                                    <span @click="previousPage"
                                          :class="['page-box', { 'disabled': currentPage === 0 }]">
                                        <span class="navigation-symbol">«</span>
                                    </span>
                                    <span v-for="page in pagesToShow"
                                          :key="page"
                                          @click="goToPage(page)"
                                          :class="['page-box',page === currentPage ? 'btn btn-primary-soft' : '']">
                                        {{ page + 1 }}
                                    </span>

                                    <span @click="nextPage"
                                          :class="['page-box', { 'disabled': !temProximaPagina }]">
                                        <span class="navigation-symbol">»</span>
                                    </span>
                                </div> <!-- pagination-controll -->
                                <span class="footer-records-text">Registros encontrados: {{ qtdRegistros }}</span>
                            </div> <!-- custom-table-footer -->
                        </div><!-- table-wrapper -->
                    </div><!-- table-container -->
                </div><!-- tyn-section -->
            </div><!-- tyn-main -->
        </div><!-- tyn-content -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>
        <div class="modal fade modern-modal" id="ModalInclusao" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-lg">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            data-bs-dismiss="modal" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>{{ modoEdicao ? 'Editar Item' : 'Novo Item' }}</h2>
                            <p>
                                {{modoEdicao ? 'Altere as informações e salve para atualizar o item no catálogo.' : 'Complete os campos para cadastrar um novo item no catálogo.'}}
                            </p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="form-group-wrapper">
                            <div class="form-field-group" :class="{ 'field-readonly': bloqueiaNomeETipo }">
                                <label class="form-label">
                                    Nome do Item <span class="text-danger">*</span>
                                </label>
                                <input type="text"
                                       v-model.trim="formInclusao.nmItem"
                                       class="form-control"
                                       :class="{ 'is-invalid': camposInvalidos.nmItem }"
                                       :disabled="bloqueiaNomeETipo"
                                       placeholder="Ex: Monitor 24&quot; LED">
                                <div v-if="camposInvalidos.nmItem" class="invalid-feedback">
                                    Informe o nome do item.
                                </div>
                            </div>
                            <div class="form-field-group">
                                <label class="form-label">
                                    Descrição do Item
                                </label>
                                <input type="text"
                                       v-model.trim="formInclusao.dsItem"
                                       class="form-control"
                                       :class="{ 'is-invalid': camposInvalidos.dsItem }"
                                       maxlength="500">
                                <div v-if="camposInvalidos.dsItem" class="invalid-feedback">
                                    Informe a descrição do item.
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-field-group col-6" :class="{ 'field-readonly': bloqueiaCdItem }">
                                    <label class="form-label">
                                        Código
                                    </label>
                                    <input type="text"
                                           inputmode="numeric"
                                           pattern="[0-9]*"
                                           maxlength="100"
                                           v-model="formInclusao.cdItem"
                                           @input="onCdItemInput"
                                           class="form-control"
                                           :class="{ 'is-invalid': camposInvalidos.cdItem }"
                                           :disabled="bloqueiaCdItem"
                                           placeholder="Informe o código único do item">
                                    <div v-if="camposInvalidos.cdItem" class="invalid-feedback">
                                        Informe o código único do item
                                    </div>
                                </div>
                                <div class="form-field-group col-6" :class="{ 'field-readonly': bloqueiaNomeETipo }">
                                    <label class="form-label">
                                        Tipo do Item <span class="text-danger">*</span>
                                    </label>
                                    <select v-model="formInclusao.tpItem"
                                            class="form-select"
                                            :class="{ 'is-invalid': camposInvalidos.tpItem }"
                                            :disabled="bloqueiaNomeETipo">
                                        <option value="" disabled>Selecione...</option>
                                        <option value="M">Material</option>
                                        <option value="S">Serviço</option>
                                    </select>
                                    <div v-if="camposInvalidos.tpItem" class="invalid-feedback">
                                        Selecione o tipo do item.
                                    </div>
                                </div>
                            </div>
                            <div class="form-field-group">
                                <label class="form-label">
                                    Código de Referência
                                </label>
                                <input type="text"
                                       v-model.trim="formInclusao.cdReferencia"
                                       class="form-control"
                                       placeholder="Ex: CÓD-INTERNO-123">
                            </div>
                        </div>
                    </div>
                    <div class="modal-modern-footer">
                        <button type="button" class="modern-btn modern-btn-primary w-100" @click="salvarCatalogoItem" :disabled="salvando || bloqueadoImportacao">
                            <span v-if="!salvando">Salvar Item</span>
                            <span v-else>Salvando...</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade modern-modal" id="ModalImportacaoCat" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-lg">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            data-bs-dismiss="modal" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Importar do CatMat / CatSer</h2>
                            <p>Escolha o tipo e refine pelos níveis (grupo, classe, etc.) para importar os itens.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <!-- Tipo de Importação -->
                        <div class="import-section">
                            <label class="form-label">
                                Tipo de Importação
                            </label>
                            <div class="origin-buttons">
                                <!-- Base inteira -->
                                <label class="origin-button"
                                       :class="{ 'active': formImportacao.modoImportacao === 'ALL' }">
                                    <input type="radio"
                                           value="ALL"
                                           v-model="formImportacao.modoImportacao"
                                           hidden>
                                    <span class="button-content">
                                        <span class="button-title">Base inteira (CatMat + CatSer)</span>
                                    </span>
                                </label>

                                <!-- Por grupo/material/serviço -->
                                <label class="origin-button"
                                       :class="{ 'active': formImportacao.modoImportacao === 'GRUPO' }">
                                    <input type="radio"
                                           value="GRUPO"
                                           v-model="formImportacao.modoImportacao"
                                           hidden>
                                    <span class="button-content">
                                        <span class="button-title">Por grupo de material/serviço</span>
                                    </span>
                                </label>

                                <!-- Código específico -->
                                <label class="origin-button"
                                       :class="{ 'active': formImportacao.modoImportacao === 'CODIGO' }">
                                    <input type="radio"
                                           value="CODIGO"
                                           v-model="formImportacao.modoImportacao"
                                           hidden>
                                    <span class="button-content">
                                        <span class="button-title">Código específico</span>
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div class="separator-line"></div>

                        <!-- Origem da Importação -->
                        <div v-if="formImportacao.modoImportacao === 'GRUPO'" class="import-section">
                            <label class="form-label">
                                Origem da Importação
                            </label>
                            <div class="origin-buttons">
                                <label class="origin-button"
                                       :class="{'active': formImportacao.tipoOrigem === 'M' && formImportacao.modoImportacao === 'GRUPO', 'disabled': formImportacao.modoImportacao !== 'GRUPO'}">
                                    <input type="radio"
                                           id="origemMaterial"
                                           value="M"
                                           v-model="formImportacao.tipoOrigem"
                                           @change="onTipoOrigemChange"
                                           :disabled="formImportacao.modoImportacao !== 'GRUPO'"
                                           hidden>
                                    <span class="button-content">
                                        <span class="button-title">CatMat - Materiais</span>
                                    </span>
                                </label>
                                <label class="origin-button"
                                       :class="{ 'active': formImportacao.tipoOrigem === 'S' && formImportacao.modoImportacao === 'GRUPO', 'disabled': formImportacao.modoImportacao !== 'GRUPO'}">
                                    <input type="radio"
                                           id="origemServico"
                                           value="S"
                                           v-model="formImportacao.tipoOrigem"
                                           @change="onTipoOrigemChange"
                                           :disabled="formImportacao.modoImportacao !== 'GRUPO'"
                                           hidden>
                                    <span class="button-content">
                                        <span class="button-title">CatSer - Serviços</span>
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div class="separator-line"></div>
                        <!-- Código Específico -->
                        <div v-if="formImportacao.modoImportacao === 'CODIGO'" class="import-section">
                            <label class="form-label">Buscar Item/Serviço (mín. 4 caracteres)</label>

                            <v-select v-model="formImportacao.itemSelecionado"
                                      :options="listaItensLookup"
                                      :filterable="false"
                                      :clearable="true"
                                      :loading="buscandoLookup"
                                      @search="onSearchItensLookup"
                                      :get-option-label="opt => `${opt.cdItem} - ${opt.dsItem || opt.nmItem || ''}`"
                                      placeholder="Digite ao menos 4 caracteres...">
                                <template #no-options>
                                    <span>Digite ao menos 4 caracteres para buscar.</span>
                                </template>
                            </v-select>

                            <small class="text-muted d-block mt-2">
                                No modo “Item específico”, a importação será feita apenas para o item selecionado.
                            </small>
                        </div>


                        <!-- Filtros CatMat -->
                        <div v-if="formImportacao.tipoOrigem === 'M' && !formImportacao.importAll" class="filter-section">
                            <div class="filter-header">
                                <h5>Filtros de Materiais (CatMat)</h5>
                            </div>
                            <div class="filter-content">
                                <div class="row g-4">
                                    <div class="col-md-6">
                                        <label class="form-label">Grupo</label>
                                        <v-select v-model="formImportacao.grupoMaterial"
                                                  :options="listaGrupoMaterial"
                                                  :get-option-label="opt => `${opt.codigoGrupo} - ${opt.nomeGrupo}`"
                                                  @input="onChangeGrupoMaterial"
                                                  :clearable="true"
                                                  placeholder="Selecione ou digite..." />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Classe</label>
                                        <v-select v-model="formImportacao.classeMaterial"
                                                  :options="listaClasseMaterial"
                                                  :get-option-label="opt => `${opt.codigoClasse} - ${opt.nomeClasse}`"
                                                  @input="onChangeClasseMaterial"
                                                  :clearable="true"
                                                  :disabled="listaClasseMaterial.length === 0"
                                                  placeholder="Selecione ou digite..." />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">PDM</label>
                                        <v-select v-model="formImportacao.pdmMaterial"
                                                  :options="listaPdmMaterial"
                                                  :get-option-label="opt => `${opt.codigoPdm} - ${opt.nomePdm}`"
                                                  :clearable="true"
                                                  :disabled="listaPdmMaterial.length === 0"
                                                  placeholder="Selecione ou digite..." />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Filtros CatSer -->
                        <div v-if="formImportacao.tipoOrigem === 'S' && !formImportacao.importAll" class="filter-section">
                            <div class="filter-header">
                                <h5>Filtros de Serviços (CatSer)</h5>
                            </div>
                            <div class="filter-content">
                                <div class="row g-4">
                                    <div class="col-md-6">
                                        <label class="form-label">Seção</label>
                                        <v-select v-model="formImportacao.secaoServico"
                                                  :options="listaSecaoServico"
                                                  :get-option-label="opt => `${opt.codigoSecao} - ${opt.nomeSecao}`"
                                                  @input="onChangeSecaoServico"
                                                  :clearable="true"
                                                  placeholder="Selecione ou digite..." />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Divisão</label>
                                        <v-select v-model="formImportacao.divisaoServico"
                                                  :options="listaDivisaoServico"
                                                  :get-option-label="opt => `${opt.codigoDivisao} - ${opt.nomeDivisao}`"
                                                  @input="onChangeDivisaoServico"
                                                  :clearable="true"
                                                  :disabled="listaDivisaoServico.length === 0"
                                                  placeholder="Selecione ou digite..." />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Grupo</label>
                                        <v-select v-model="formImportacao.grupoServico"
                                                  :options="listaGrupoServico"
                                                  :get-option-label="opt => `${opt.codigoGrupo} - ${opt.nomeGrupo}`"
                                                  @input="onChangeGrupoServico"
                                                  :clearable="true"
                                                  :disabled="listaGrupoServico.length === 0"
                                                  placeholder="Selecione ou digite..." />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Classe</label>
                                        <v-select v-model="formImportacao.classeServico"
                                                  :options="listaClasseServico"
                                                  :get-option-label="opt => `${opt.codigoClasse} - ${opt.nomeClasse}`"
                                                  @input="onChangeClasseServico"
                                                  :clearable="true"
                                                  :disabled="listaClasseServico.length === 0"
                                                  placeholder="Selecione ou digite..." />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Subclasse</label>
                                        <v-select v-model="formImportacao.subclasseServico"
                                                  :options="listaSubclasseServico"
                                                  :get-option-label="opt => `${opt.codigoSubclasse} - ${opt.nomeSubclasse}`"
                                                  :clearable="true"
                                                  :disabled="listaSubclasseServico.length === 0"
                                                  placeholder="Selecione ou digite..." />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Dica -->
                        <div class="info-tip" v-if="formImportacao.modoImportacao === 'GRUPO'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16" class="tip-icon">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                            </svg>
                            <span><strong>Dica:</strong> Você pode importar por nível. Ex: selecionar só o grupo já importa todos os itens daquele grupo.</span>
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button"
                                class="modern-btn modern-btn-primary w-100"
                                :disabled="!podeImportar || importando || bloqueadoImportacao"
                                @click="importarItensCgov">
                            <span v-if="!importando">Importar Itens Selecionados</span>
                            <span v-else>Importando...</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <ModalImportacaoCatalogoItens ref="modalImportacaoCatalogo"
                                      @import-finished="load" />
    </div> <!-- tyn-root-->
</template>
<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import ModalImportacaoCatalogoItens from '@/components/ModalImportacaoCatalogoItens'
    import axios from 'axios'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import Swal from 'sweetalert2'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'

    // Máximo de itens por exclusão (igual a CatalogoItensController.MaxItensExclusao).
    const LIMITE_EXCLUSAO = 10000

    export default {
        name: 'CatalogoItens',
        components: { Header, Modais, 'v-select': vSelect, ModalImportacaoCatalogoItens },
        data: function () {
            return {
                pagFilter: '',
                itens: [],
                tipoItens: [],
                tipoItensMap: {},
                qtdRegistros: 0,
                carregandoItens: true,
                mostrarModalInclusao: false,
                currentPage: 0,
                pageSize: 10,
                debounceTimeout: null,
                formInclusao: {
                    idItem: 0,
                    nmItem: '',
                    dsItem: '',
                    tpItem: '',
                    cdItem: '',
                    cdReferencia: '',
                    flPadrao: false,
                    idTipoItem: null
                },
                modoEdicao: false,
                camposInvalidos: {
                    nmItem: false,
                    tpItem: false,
                    cdItem: false
                },
                salvando: false,
                modalInclusaoInstance: null,
                modalImportacaoInstance: null,
                importando: false,
                formImportacao: {
                    modoImportacao: 'ALL',
                    tipoOrigem: null,
                    importAll: false,
                    codigoItem: '',
                    // Materiais
                    grupoMaterial: null,
                    classeMaterial: null,
                    pdmMaterial: null,
                    // Serviços
                    secaoServico: null,
                    divisaoServico: null,
                    grupoServico: null,
                    classeServico: null,
                    subclasseServico: null,
                    itemSelecionado: null,
                },
                listaGrupoMaterial: [],
                listaClasseMaterial: [],
                listaPdmMaterial: [],
                listaSecaoServico: [],
                listaDivisaoServico: [],
                listaGrupoServico: [],
                listaClasseServico: [],
                listaSubclasseServico: [],
                filtroGrupoMaterial: '',
                filtroClasseMaterial: '',
                filtroPdmMaterial: '',
                filtroSecaoServico: '',
                filtroDivisaoServico: '',
                filtroGrupoServico: '',
                filtroClasseServico: '',
                filtroSubclasseServico: '',
                listaItensLookup: [],
                buscandoLookup: false,
                lookupDebounce: null,
                //bloqueio novo
                bloqueadoImportacao: false,
                statusImportacaoAtual: null,
                mensagemBloqueio: '',
                carregandoStatusImportacao: false,
                intervaloStatusImportacao: null,
                modoExclusao: false,
                idsSelecionados: {},
                menuSelecaoAberto: false,
                marcandoTodos: false,
                excluindoItens: false,
                abortCatalogoItens: null,
                termoCarregado: '',
                pedidoMarcarTodos: 0,
            }
        },
        watch: {
            pagFilter: {
                handler() {
                    this.menuSelecaoAberto = false;
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = setTimeout(() => {
                        this.currentPage = 0;
                        this.getCatalogoItens();
                    }, 500);
                }
            },
            'formImportacao.modoImportacao'(val) {
                this.formImportacao.itemSelecionado = null;
                this.listaItensLookup = [];

                if (val === 'ALL') {
                    this.formImportacao.codigoItem = '';
                    this.formImportacao.tipoOrigem = null;
                    this.clearMaterialFilters();
                    this.clearServicoFilters();
                } else if (val === 'CODIGO') {
                    this.formImportacao.tipoOrigem = null;
                    this.clearMaterialFilters();
                    this.clearServicoFilters();
                } else if (val === 'GRUPO') {
                    this.formImportacao.codigoItem = '';
                }
            }
        },

        methods: {
            load() {
                this.getStatus();
            },

            loadDadosTela() {
                let $this = this;

                $this.getTipoItem().then(() => {
                    $this.getCatalogoItens();
                });
            },

            iniciarMonitoramentoImportacao() {
                if (this.intervaloStatusImportacao) return;

                this.intervaloStatusImportacao = setInterval(() => {
                    this.getStatus({ silencioso: true });
                }, 10000);
            },

            pararMonitoramentoImportacao() {
                if (!this.intervaloStatusImportacao) return;

                clearInterval(this.intervaloStatusImportacao);
                this.intervaloStatusImportacao = null;
            },

            recarregarStatusImportacao() {
                this.getStatus();
            },

            getStatus(options = {}) {
                const { silencioso = false } = options;
                let $this = this;
                const estavaBloqueado = $this.bloqueadoImportacao;

                if (!silencioso) {
                    $this.carregandoStatusImportacao = true;
                }

                axios.get(`${urlApi}/CatalogoItens/GetStatus`)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            const itemStatus = result?.itemStatus || null;

                            $this.statusImportacaoAtual = itemStatus;
                            if (!itemStatus) {
                                $this.bloqueadoImportacao = false;
                                $this.mensagemBloqueio = '';
                                $this.pararMonitoramentoImportacao();
                                $this.loadDadosTela();
                                return;
                            }
                            const status = (itemStatus.dsStatus || '').trim().toUpperCase();

                            if (status === 'INICIADO') {
                                $this.bloqueadoImportacao = true;
                                $this.mensagemBloqueio = 'Existe uma importação em andamento para este cliente. Aguarde a conclusão para continuar.';
                                $this.itens = [];
                                $this.qtdRegistros = 0;
                                $this.iniciarMonitoramentoImportacao();
                                return;
                            }

                            $this.bloqueadoImportacao = false;
                            $this.mensagemBloqueio = '';
                            $this.pararMonitoramentoImportacao();
                            $this.loadDadosTela();

                            if (estavaBloqueado && !silencioso) {
                                if (status === 'FINALIZADO') {
                                    avisoToast('Importação finalizada. A tela foi atualizada.', "success");
                                } else if (status === 'CANCELADO') {
                                    avisoToast('A importação foi cancelada. Dados recarregados.', "warning");
                                }
                            }
                        } else {
                            console.warn("Resposta sem sucesso");
                            $this.bloqueadoImportacao = true;
                            $this.mensagemBloqueio = 'Não foi possível validar o status da importação.';
                            $this.iniciarMonitoramentoImportacao();
                            if (!silencioso) {
                                avisoToast("Erro ao validar status da importação!", "warning");
                            }
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        $this.bloqueadoImportacao = true;
                        $this.mensagemBloqueio = 'Erro ao consultar status da importação.';
                        $this.iniciarMonitoramentoImportacao();
                        if (!silencioso) {
                            avisoToast("Erro ao consultar status da importação!", "warning");
                        }
                    })
                    .finally(() => {
                        if (!silencioso) {
                            $this.carregandoStatusImportacao = false;
                        }
                    });
            },

            async onSearchItensLookup(search) {
                const termo = (search || '').trim();

                if (termo.length < 4) {
                    this.listaItensLookup = [];
                    return;
                }

                clearTimeout(this.lookupDebounce);
                this.lookupDebounce = setTimeout(async () => {
                    this.buscandoLookup = true;
                    try {
                        const res = await axios.get(`${urlApi}/CatalogoItens/Get`, {
                            params: {
                                dsTermo: termo,
                                take: 20,
                                index: 0,
                                orderBy: "tbCGovItens.cdItem ASC"
                            }
                        });

                        if (res.data?.success) {
                            const rows = res.data.data?.rows || [];
                            this.listaItensLookup = rows
                                .map(r => r.cgovItem || r.item || r)
                                .filter(x => x && x.idCgovItem);
                        } else {
                            this.listaItensLookup = [];
                        }
                    } catch (e) {
                        console.error(e);
                        this.listaItensLookup = [];
                    } finally {
                        this.buscandoLookup = false;
                    }
                }, 350);
            },

            getCatalogoItens() {
                if (this.bloqueadoImportacao) {
                    this.itens = [];
                    this.qtdRegistros = 0;
                    this.carregandoItens = false;
                    return;
                }

                let $this = this;
                // Cancela a carga anterior: só a resposta da última busca/página vale.
                if ($this.abortCatalogoItens) $this.abortCatalogoItens.abort();
                const controle = new AbortController();
                $this.abortCatalogoItens = controle;
                const aindaVale = () => $this.abortCatalogoItens === controle;
                const termoPedido = $this.pagFilter || '';

                $this.menuSelecaoAberto = false;
                $this.carregandoItens = true;
                axios.get(`${urlApi}/CadastroItem/Get`, {
                    signal: controle.signal,
                    params: {
                        index: $this.currentPage,
                        take: $this.pageSize,
                        dsTermo: termoPedido
                    }
                })
                    .then(res => {
                        if (!aindaVale()) return;
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.termoCarregado = termoPedido;

                            $this.itens = result.rows.map(p => {
                                const item = { ...p.item };
                                item.nmTipoItem = $this.tipoItensMap[item.idTipoItem] || '';
                                item.nmTpItem =
                                    item.tpItem === 'M'
                                        ? 'Material'
                                        : item.tpItem === 'S'
                                            ? 'Serviço'
                                            : '';

                                return item;
                            });

                            $this.qtdRegistros = result.qtdRecords;
                        } else {
                            console.warn("Resposta sem sucesso");
                            $this.itens = [];
                            $this.qtdRegistros = 0;
                        }
                    })
                    .catch(err => {
                        if (!aindaVale() || err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') return;
                        $this.termoCarregado = termoPedido;
                        console.error("Erro ao fazer requisição:", err);
                        avisoToast("Erro ao carregar itens!", "warning");
                        $this.itens = [];
                        $this.qtdRegistros = 0;
                    })
                    .finally(() => {
                        if (!aindaVale()) return;
                        $this.abortCatalogoItens = null;
                        $this.carregandoItens = false;
                    });
            },

            getTipoItem() {
                let $this = this;
                return axios.get(`${urlApi}/CatalogoItens/GetTipoItem`)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;

                            $this.tipoItens = result;
                            $this.tipoItensMap = result.reduce((map, tipo) => {
                                map[tipo.idTipoItem] = tipo.nmTipoItem;
                                return map;
                            }, {});
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        avisoToast("Erro ao carregar tipos de item!", "warning");
                    });
            },

            resetFormInclusao() {
                this.formInclusao = {
                    idItem: 0,
                    nmItem: '',
                    dsItem: '',
                    tpItem: '',
                    cdItem: '',
                    cdReferencia: '',
                    flPadrao: false,
                    idTipoItem: null
                };

                this.camposInvalidos = {
                    nmItem: false,
                    tpItem: false,
                    cdItem: false
                };
            },

            onCdItemInput(event) {
                const digits = String(event.target.value || '').replace(/\D/g, '').slice(0, 100);
                this.formInclusao.cdItem = digits;
                event.target.value = digits;
                this.camposInvalidos.cdItem = false;
            },

            abrirModalItem() {
                const el = document.getElementById('ModalInclusao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;

                if (bs && bs.Modal) {
                    if (!this.modalInclusaoInstance) {
                        this.modalInclusaoInstance = new bs.Modal(el, {
                            backdrop: true,
                            keyboard: true
                        });
                    }
                    this.modalInclusaoInstance.show();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('show');
                }
            },

            abrirModalInclusao() {
                this.modoEdicao = false;
                this.resetFormInclusao();
                this.abrirModalItem();
            },

            abrirDetalhes(idItem) {
                const item = this.itens.find(i => i.idItem === idItem);

                if (!item) {
                    avisoToast("Item não encontrado para edição.", "warning");
                    return;
                }

                this.formInclusao = {
                    idItem: item.idItem,
                    nmItem: item.nmItem || '',
                    dsItem: item.dsItem || '',
                    tpItem: item.tpItem || '',
                    cdItem: item.cdItem || '',
                    cdReferencia: item.cdReferencia || '',
                    flPadrao: !!item.flPadrao,
                    idTipoItem: item.idTipoItem ?? null
                };

                this.camposInvalidos = {
                    nmItem: false,
                    tpItem: false,
                    cdItem: false
                };

                this.modoEdicao = true;
                this.abrirModalItem();
            },

            abrirModalImportacaoExcel() {
                const comp = this.$refs.modalImportacaoCatalogo;

                if (comp && typeof comp.abrirModal === 'function') {
                    comp.abrirModal(() => {
                        this.getCatalogoItens();
                    });
                } else {
                    console.error('Componente ModalImportacaoCatalogoItens não encontrado ou sem método abrirModal.');
                }
            },

            abrirModalImportacao() {
                this.formImportacao = {
                    modoImportacao: 'ALL',
                    tipoOrigem: null,
                    importAll: false,
                    codigoItem: '',
                    grupoMaterial: null,
                    classeMaterial: null,
                    pdmMaterial: null,
                    secaoServico: null,
                    divisaoServico: null,
                    grupoServico: null,
                    classeServico: null,
                    subclasseServico: null,
                    itemSelecionado: null,
                };

                this.listaItensLookup = [];
                this.clearMaterialFilters();
                this.clearServicoFilters();

                const el = document.getElementById('ModalImportacaoCat');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;

                if (bs && bs.Modal) {
                    if (!this.modalImportacaoInstance) {
                        this.modalImportacaoInstance = new bs.Modal(el, {
                            backdrop: true,
                            keyboard: true
                        });
                    }
                    this.modalImportacaoInstance.show();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('show');
                }

                this.carregarGrupoMaterial();
                this.carregarSecaoServico();
            },

            salvarCatalogoItem() {
                let $this = this;
                $this.camposInvalidos.nmItem = !$this.formInclusao.nmItem || !$this.formInclusao.nmItem.trim();
                $this.camposInvalidos.tpItem = !$this.formInclusao.tpItem;

                const cdItemRaw = String($this.formInclusao.cdItem || '').trim();
                const cdItem = $this.bloqueiaCdItem
                    ? cdItemRaw
                    : cdItemRaw.replace(/\D/g, '').slice(0, 100);
                $this.formInclusao.cdItem = cdItem;
                $this.camposInvalidos.cdItem = !$this.bloqueiaCdItem && !!cdItem && !/^\d{1,100}$/.test(cdItem);

                if ($this.camposInvalidos.nmItem || $this.camposInvalidos.tpItem) {
                    avisoToast("Preencha os campos obrigatórios.", "warning");
                    return;
                }

                if ($this.camposInvalidos.cdItem) {
                    avisoToast("O código deve conter somente números, com até 100 caracteres.", "warning");
                    return;
                }

                const payload = {
                    DadosItem: {
                        idItem: $this.formInclusao.idItem || 0,
                        nmItem: $this.formInclusao.nmItem.trim(),
                        dsItem: $this.formInclusao.dsItem.trim(),
                        tpItem: $this.formInclusao.tpItem,
                        cdItem: cdItem || null,
                        cdReferencia: $this.formInclusao.cdReferencia
                            ? $this.formInclusao.cdReferencia.trim()
                            : null
                    }
                };

                $this.salvando = true;

                axios.post(`${urlApi}/CatalogoItens/PostCatalogoItem`, payload)
                    .then(res => {
                        if (res.data && res.data.success) {
                            avisoToast("Item salvo com sucesso!", "success");
                            $this.fecharModalInclusao();
                            $this.getCatalogoItens();
                        } else {
                            const msg = (res.data && res.data.msg) ? res.data.msg : "Erro ao salvar item!";
                            avisoErro(msg);
                            avisoToast(msg, "warning");
                        }
                    })
                    .catch(err => {
                        const data = err.response && err.response.data ? err.response.data : null;
                        const detalhes = data && Array.isArray(data.errors)
                            ? data.errors.filter(Boolean).join(' ')
                            : '';
                        const msg = [data && data.msg, detalhes].filter(Boolean).join(' - ')
                            || err.message
                            || "Erro ao salvar item!";

                        avisoErro(msg);
                        avisoToast(msg, "warning");
                    })
                    .finally(() => {
                        $this.salvando = false;
                    });
            },

            previousPage() {
                if (this.currentPage > 0) {
                    this.currentPage--;
                    this.getCatalogoItens();
                }
            },

            nextPage() {
                if (this.temProximaPagina) {
                    this.currentPage++;
                    this.getCatalogoItens();
                }
            },

            goToPage(pageIndex) {
                if (pageIndex !== this.currentPage) {
                    this.currentPage = pageIndex;
                    this.getCatalogoItens();
                }
            },

            entrarModoExclusao(idItem) {
                this.modoExclusao = true;
                this.menuSelecaoAberto = false;
                this.pedidoMarcarTodos++;
                this.idsSelecionados = {};
                if (idItem) this.$set(this.idsSelecionados, idItem, true);
            },

            cancelarModoExclusao() {
                this.modoExclusao = false;
                this.menuSelecaoAberto = false;
                this.pedidoMarcarTodos++;
                this.marcandoTodos = false;
                this.idsSelecionados = {};
            },

            avisarLimiteExclusao() {
                avisoToast(`A seleção foi limitada a ${this.limiteExclusaoFormatado} itens.`, "warning");
            },

            // Adiciona ids à seleção sem passar do limite. Retorna true se algum ficou de fora.
            adicionarSelecao(ids) {
                const selecionados = { ...this.idsSelecionados };
                let qtd = Object.keys(selecionados).length;
                let limitado = false;
                for (const id of ids) {
                    if (selecionados[id]) continue;
                    if (qtd >= LIMITE_EXCLUSAO) { limitado = true; break; }
                    selecionados[id] = true;
                    qtd++;
                }
                this.idsSelecionados = selecionados;
                if (limitado) this.avisarLimiteExclusao();
                return limitado;
            },

            alternarSelecaoItem(idItem, marcado) {
                if (marcado) return !this.adicionarSelecao([idItem]);
                this.$delete(this.idsSelecionados, idItem);
                return true;
            },

            onCheckboxItem(idItem, event) {
                const aplicado = this.alternarSelecaoItem(idItem, event.target.checked);
                // Sem vaga no limite: desfaz o check no DOM.
                if (!aplicado) event.target.checked = false;
            },

            alternarSelecaoPagina(marcado) {
                if (this.selecaoBloqueada) return;
                const ids = this.itens.map(item => item.idItem);
                if (marcado) {
                    this.adicionarSelecao(ids);
                } else {
                    const selecionados = { ...this.idsSelecionados };
                    ids.forEach(id => { delete selecionados[id]; });
                    this.idsSelecionados = selecionados;
                }
            },

            marcarPaginaAtual() {
                this.menuSelecaoAberto = false;
                this.alternarSelecaoPagina(true);
            },

            desmarcarTodos() {
                this.menuSelecaoAberto = false;
                this.pedidoMarcarTodos++;
                this.marcandoTodos = false;
                this.idsSelecionados = {};
            },

            marcarTodos(somenteBusca) {
                this.menuSelecaoAberto = false;
                if (this.selecaoBloqueada) return;
                // Usa o termo da lista exibida, não o que está sendo digitado.
                const termo = somenteBusca ? this.termoCarregado : null;
                if (somenteBusca && !(termo && termo.trim())) return;

                const pedido = ++this.pedidoMarcarTodos;
                const aindaVale = () => pedido === this.pedidoMarcarTodos && this.modoExclusao;
                this.marcandoTodos = true;
                axios.get(`${urlApi}/CatalogoItens/GetIds`, {
                    params: { dsTermo: termo }
                })
                    .then(res => {
                        if (!aindaVale()) return;
                        if (res.data.success) {
                            this.adicionarSelecao(res.data.data || []);
                        } else {
                            avisoToast(res.data.msg || "Erro ao marcar itens!", "warning");
                        }
                    })
                    .catch(err => {
                        if (!aindaVale()) return;
                        console.error("Erro ao marcar itens:", err);
                        avisoToast("Erro ao marcar itens!", "warning");
                    })
                    .finally(() => {
                        if (aindaVale()) this.marcandoTodos = false;
                    });
            },

            escaparHtml(texto) {
                return String(texto == null ? '' : texto)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            },

            excluirSelecionados() {
                const ids = Object.keys(this.idsSelecionados).map(Number);
                if (ids.length === 0) {
                    avisoToast("Selecione ao menos um item para excluir.", "warning");
                    return;
                }

                Swal.fire({
                    title: 'Tem certeza?',
                    text: ids.length === 1
                        ? '1 item será excluído. Essa ação não poderá ser desfeita!'
                        : `${ids.length} itens serão excluídos. Essa ação não poderá ser desfeita!`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, excluir!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (!result.isConfirmed) return;

                    this.excluindoItens = true;
                    axios.post(`${urlApi}/CatalogoItens/DeleteItens`, { idsItem: ids })
                        .then(res => {
                            if (!res.data.success) {
                                const erroMsg = res.data.msg || "Erro ao excluir itens!";
                                avisoErro(erroMsg);
                                avisoToast(erroMsg, "warning");
                                return;
                            }

                            const resultado = res.data.data || {};
                            const excluidos = resultado.excluidos || [];
                            const emUso = resultado.emUso || [];

                            if (excluidos.length > 0) {
                                avisoToast(excluidos.length === 1
                                    ? "1 item excluído com sucesso!"
                                    : `${excluidos.length} itens excluídos com sucesso!`, "success");
                            }

                            if (emUso.length > 0) {
                                const lista = emUso
                                    .map(i => `<li>${this.escaparHtml(i.cdItem)} - ${this.escaparHtml(i.nmItem)}</li>`)
                                    .join('');
                                Swal.fire({
                                    title: 'Itens não excluídos',
                                    html: `<p>Os itens abaixo não foram excluídos por estarem em uso:</p><ul style="text-align:left; max-height:300px; overflow:auto;">${lista}</ul>`,
                                    icon: 'info',
                                    confirmButtonText: 'OK'
                                });
                            }

                            this.cancelarModoExclusao();
                            this.getCatalogoItens();
                        })
                        .catch(err => {
                            console.error("Erro ao excluir itens:", err);
                            if (err.response && err.response.data) {
                                avisoErro(err.response.data);
                                avisoToast("Erro ao excluir itens!", "warning");
                            } else {
                                avisoErro(err.message || "Erro desconhecido");
                            }
                        })
                        .finally(() => {
                            this.excluindoItens = false;
                        });
                });
            },

            fecharModalInclusao() {
                const el = document.getElementById('ModalInclusao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;

                if (bs && bs.Modal) {
                    if (this.modalInclusaoInstance) {
                        this.modalInclusaoInstance.hide();
                    } else {
                        const modalInstance = bs.Modal.getInstance(el);
                        if (modalInstance) modalInstance.hide();
                    }
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('hide');
                }
            },

            fecharModalImportacao() {
                const el = document.getElementById('ModalImportacaoCat');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;

                if (bs && bs.Modal) {
                    if (this.modalImportacaoInstance) {
                        this.modalImportacaoInstance.hide();
                    } else {
                        const modalInstance = bs.Modal.getInstance(el);
                        if (modalInstance) modalInstance.hide();
                    }
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('hide');
                }
            },
            // -- CATMAT --
            carregarGrupoMaterial() {
                axios.get(`${urlApi}/CatMatSer/modulo-material/1_consultarGrupoMaterial`, {
                    params: {
                        pagina: 1,
                        statusGrupo: true
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.listaGrupoMaterial = res.data.data.resultado || [];
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar grupos de material:", err);
                        avisoToast("Erro ao carregar grupos de material!", "warning");
                    });
            },

            onChangeGrupoMaterial() {
                this.formImportacao.classeMaterial = null;
                this.formImportacao.pdmMaterial = null;
                this.listaClasseMaterial = [];
                this.listaPdmMaterial = [];

                if (!this.formImportacao.grupoMaterial) return;

                const codigoGrupo = this.formImportacao.grupoMaterial.codigoGrupo;

                axios.get(`${urlApi}/CatMatSer/modulo-material/2_consultarClasseMaterial`, {
                    params: {
                        pagina: 1,
                        codigoGrupo: codigoGrupo,
                        statusClasse: true
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.listaClasseMaterial = res.data.data.resultado || [];
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar classes de material:", err);
                        avisoToast("Erro ao carregar classes de material!", "warning");
                    });
            },

            onChangeClasseMaterial() {
                this.formImportacao.pdmMaterial = null;
                this.listaPdmMaterial = [];

                if (!this.formImportacao.classeMaterial) return;

                const codigoGrupo = this.formImportacao.grupoMaterial?.codigoGrupo;
                const codigoClasse = this.formImportacao.classeMaterial.codigoClasse;

                axios.get(`${urlApi}/CatMatSer/modulo-material/3_consultarPdmMaterial`, {
                    params: {
                        pagina: 1,
                        codigoGrupo: codigoGrupo,
                        codigoClasse: codigoClasse,
                        statusPdm: true
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.listaPdmMaterial = res.data.data.resultado || [];
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar PDMs de material:", err);
                        avisoToast("Erro ao carregar PDMs de material!", "warning");
                    });
            },

            // -- CATSER --
            carregarSecaoServico() {
                axios.get(`${urlApi}/CatMatSer/modulo-servico/1_consultarSecaoServico`, {
                    params: {
                        pagina: 1,
                        statusSecao: true
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.listaSecaoServico = res.data.data.resultado || [];
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar seções de serviço:", err);
                        avisoToast("Erro ao carregar seções de serviço!", "warning");
                    });
            },

            onChangeSecaoServico() {
                this.formImportacao.divisaoServico = null;
                this.formImportacao.grupoServico = null;
                this.formImportacao.classeServico = null;
                this.formImportacao.subclasseServico = null;
                this.listaDivisaoServico = [];
                this.listaGrupoServico = [];
                this.listaClasseServico = [];
                this.listaSubclasseServico = [];

                if (!this.formImportacao.secaoServico) return;

                const codigoSecao = this.formImportacao.secaoServico.codigoSecao;

                axios.get(`${urlApi}/CatMatSer/modulo-servico/2_consultarDivisaoServico`, {
                    params: {
                        pagina: 1,
                        codigoSecao: codigoSecao,
                        statusDivisao: true
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.listaDivisaoServico = res.data.data.resultado || [];
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar divisões de serviço:", err);
                        avisoToast("Erro ao carregar divisões de serviço!", "warning");
                    });
            },

            onChangeDivisaoServico() {
                this.formImportacao.grupoServico = null;
                this.formImportacao.classeServico = null;
                this.formImportacao.subclasseServico = null;
                this.listaGrupoServico = [];
                this.listaClasseServico = [];
                this.listaSubclasseServico = [];

                if (!this.formImportacao.divisaoServico) return;

                const codigoDivisao = this.formImportacao.divisaoServico.codigoDivisao;

                axios.get(`${urlApi}/CatMatSer/modulo-servico/3_consultarGrupoServico`, {
                    params: {
                        pagina: 1,
                        codigoDivisao: codigoDivisao,
                        statusGrupo: true
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.listaGrupoServico = res.data.data.resultado || [];
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar grupos de serviço:", err);
                        avisoToast("Erro ao carregar grupos de serviço!", "warning");
                    });
            },

            onChangeGrupoServico() {
                this.formImportacao.classeServico = null;
                this.formImportacao.subclasseServico = null;
                this.listaClasseServico = [];
                this.listaSubclasseServico = [];

                if (!this.formImportacao.grupoServico) return;

                const codigoGrupo = this.formImportacao.grupoServico.codigoGrupo;

                axios.get(`${urlApi}/CatMatSer/modulo-servico/4_consultarClasseServico`, {
                    params: {
                        pagina: 1,
                        codigoGrupo: codigoGrupo,
                        statusGrupo: true
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.listaClasseServico = res.data.data.resultado || [];
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar classes de serviço:", err);
                        avisoToast("Erro ao carregar classes de serviço!", "warning");
                    });
            },

            onChangeClasseServico() {
                this.formImportacao.subclasseServico = null;
                this.listaSubclasseServico = [];

                if (!this.formImportacao.classeServico) return;

                const codigoClasse = this.formImportacao.classeServico.codigoClasse;

                axios.get(`${urlApi}/CatMatSer/modulo-servico/5_consultarSubClasseServico`, {
                    params: {
                        pagina: 1,
                        codigoClasse: codigoClasse,
                        statusSubclasse: true
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.listaSubclasseServico = res.data.data.resultado || [];
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar subclasses de serviço:", err);
                        avisoToast("Erro ao carregar subclasses de serviço!", "warning");
                    });
            },

            importarItensCgov() {
                if (!this.podeImportar) {
                    avisoToast("Selecione um modo de importação antes de continuar.", "warning");
                    return;
                }

                this.importando = true;

                const modo = this.formImportacao.modoImportacao;

                const payload = {
                    batchSize: 500,
                    cdItemExato: modo === 'CODIGO'
                        ? this.formImportacao.itemSelecionado?.cdItem ?? null
                        : null,

                    cdClasse: null,
                    cdGrupo: null,
                    cdSubgrupo: null,
                    cdSecao: null,
                    cdDivisao: null,
                    cdCategoriaServico: null,
                    cdFamiliaServico: null,
                    idTipoItem: null
                };

                if (modo === 'GRUPO') {
                    if (this.formImportacao.tipoOrigem === 'M') {
                        payload.idTipoItem = 1;
                        payload.cdGrupo = this.formImportacao.grupoMaterial
                            ? String(this.formImportacao.grupoMaterial.codigoGrupo)
                            : null;
                        payload.cdClasse = this.formImportacao.classeMaterial
                            ? String(this.formImportacao.classeMaterial.codigoClasse)
                            : null;
                        payload.cdSubgrupo = this.formImportacao.pdmMaterial
                            ? String(this.formImportacao.pdmMaterial.codigoPdm)
                            : null;
                    } else if (this.formImportacao.tipoOrigem === 'S') {
                        payload.idTipoItem = 2;
                        payload.cdSecao = this.formImportacao.secaoServico
                            ? String(this.formImportacao.secaoServico.codigoSecao)
                            : null;
                        payload.cdDivisao = this.formImportacao.divisaoServico
                            ? String(this.formImportacao.divisaoServico.codigoDivisao)
                            : null;
                        payload.cdGrupo = this.formImportacao.grupoServico
                            ? String(this.formImportacao.grupoServico.codigoGrupo)
                            : null;
                        payload.cdClasse = this.formImportacao.classeServico
                            ? String(this.formImportacao.classeServico.codigoClasse)
                            : null;
                        payload.cdFamiliaServico = this.formImportacao.subclasseServico
                            ? String(this.formImportacao.subclasseServico.codigoSubclasse)
                            : null;
                    }
                }

                axios.post(`${urlApi}/CatalogoItens/PostImportarItem`, payload)
                    .then(res => {
                        if (res.data && res.data.success) {
                            avisoToast("Importação iniciada com sucesso!", "success");

                            this.fecharModalImportacao();

                            this.load();
                        } else {
                            const msg = (res.data && res.data.msg)
                                ? res.data.msg
                                : "Erro ao iniciar importação!";

                            avisoErro(msg);
                            avisoToast(msg, "warning");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao iniciar importação:", err);

                        if (err.response && err.response.data && err.response.data.msg) {
                            avisoErro(err.response.data.msg);
                            avisoToast(err.response.data.msg, "warning");
                        } else {
                            avisoErro(err.message || "Erro ao iniciar importação!");
                            avisoToast("Erro ao iniciar importação!", "warning");
                        }
                    })
                    .finally(() => {
                        this.importando = false;
                    });
            },

            clearMaterialFilters() {
                this.formImportacao.grupoMaterial = null;
                this.formImportacao.classeMaterial = null;
                this.formImportacao.pdmMaterial = null;
                this.listaGrupoMaterial = [];
                this.listaClasseMaterial = [];
                this.listaPdmMaterial = [];

                this.filtroGrupoMaterial = '';
                this.filtroClasseMaterial = '';
                this.filtroPdmMaterial = '';
            },

            clearServicoFilters() {
                this.formImportacao.secaoServico = null;
                this.formImportacao.divisaoServico = null;
                this.formImportacao.grupoServico = null;
                this.formImportacao.classeServico = null;
                this.formImportacao.subclasseServico = null;
                this.listaSecaoServico = [];
                this.listaDivisaoServico = [];
                this.listaGrupoServico = [];
                this.listaClasseServico = [];
                this.listaSubclasseServico = [];

                this.filtroSecaoServico = '';
                this.filtroDivisaoServico = '';
                this.filtroGrupoServico = '';
                this.filtroClasseServico = '';
                this.filtroSubclasseServico = '';
            },

            onTipoOrigemChange() {
                if (this.formImportacao.tipoOrigem === 'M') {
                    this.clearServicoFilters();
                    if (this.listaGrupoMaterial.length === 0) {
                        this.carregarGrupoMaterial();
                    }
                } else if (this.formImportacao.tipoOrigem === 'S') {
                    this.clearMaterialFilters();
                    if (this.listaSecaoServico.length === 0) {
                        this.carregarSecaoServico();
                    }
                }
            },

        },

        mounted: function () {
            this.load();
        },
        beforeDestroy() {
            this.pararMonitoramentoImportacao();
        },

        computed: {
            qtdSelecionados() {
                return Object.keys(this.idsSelecionados).length;
            },
            buscaCarregadaAtiva() {
                return !!(this.termoCarregado && this.termoCarregado.trim());
            },
            // Seleção travada enquanto a lista carrega, a busca digitada ainda não foi aplicada
            // ou um "marcar todos" está em andamento.
            selecaoBloqueada() {
                return this.marcandoTodos || this.carregandoItens || (this.pagFilter || '') !== this.termoCarregado;
            },
            limiteExclusaoFormatado() {
                return LIMITE_EXCLUSAO.toLocaleString('pt-BR');
            },
            paginaTodaSelecionada() {
                return this.itens.length > 0 && this.itens.every(item => !!this.idsSelecionados[item.idItem]);
            },
            isItemInterno() {
                const tipo = (this.tipoItens || []).find(t => t.idTipoItem == this.formInclusao.idTipoItem);
                return !!tipo && tipo.cdTipoItem === 'IN';
            },
            isItemCgov() {
                return this.modoEdicao && !this.isItemInterno;
            },
            bloqueiaNomeETipo() {
                return this.modoEdicao && (!!this.formInclusao.flPadrao || !this.isItemInterno);
            },
            bloqueiaCdItem() {
                return this.modoEdicao && !this.isItemInterno;
            },
            totalPages() {
                return Math.ceil(this.qtdRegistros / this.pageSize);
            },
            temProximaPagina() {
                return (this.currentPage + 1) < this.totalPages;
            },
            pagesToShow() {
                const maxPages = 5;
                const pages = [];

                let start = Math.max(this.currentPage - 2, 0);
                let end = Math.min(start + maxPages, this.totalPages);

                if (end - start < maxPages) {
                    start = Math.max(end - maxPages, 0);
                }

                for (let i = start; i < end; i++) {
                    pages.push(i);
                }

                return pages;
            },
            user() {
                return this.$store.state.user
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato === 'Sim';
            },
            podeImportar() {
                const modo = this.formImportacao.modoImportacao;

                if (modo === 'ALL') return true;

                if (modo === 'CODIGO') {
                    return !!this.formImportacao.itemSelecionado?.idCgovItem;
                }

                if (modo === 'GRUPO') {
                    return this.formImportacao.tipoOrigem === 'M' || this.formImportacao.tipoOrigem === 'S';
                }

                return false;
            },

            filteredGrupoMaterial() {
                const term = (this.filtroGrupoMaterial || '').toLowerCase();
                if (!term) return this.listaGrupoMaterial;

                return this.listaGrupoMaterial.filter(g =>
                    (`${g.codigoGrupo} - ${g.nomeGrupo}`).toLowerCase().includes(term)
                );
            },

            filteredClasseMaterial() {
                const term = (this.filtroClasseMaterial || '').toLowerCase();
                if (!term) return this.listaClasseMaterial;

                return this.listaClasseMaterial.filter(c =>
                    (`${c.codigoClasse} - ${c.nomeClasse}`).toLowerCase().includes(term)
                );
            },

            filteredPdmMaterial() {
                const term = (this.filtroPdmMaterial || '').toLowerCase();
                if (!term) return this.listaPdmMaterial;

                return this.listaPdmMaterial.filter(p =>
                    (`${p.codigoPdm} - ${p.nomePdm}`).toLowerCase().includes(term)
                );
            },

            filteredSecaoServico() {
                const term = (this.filtroSecaoServico || '').toLowerCase();
                if (!term) return this.listaSecaoServico;

                return this.listaSecaoServico.filter(s =>
                    (`${s.codigoSecao} - ${s.nomeSecao}`).toLowerCase().includes(term)
                );
            },

            filteredDivisaoServico() {
                const term = (this.filtroDivisaoServico || '').toLowerCase();
                if (!term) return this.listaDivisaoServico;

                return this.listaDivisaoServico.filter(d =>
                    (`${d.codigoDivisao} - ${d.nomeDivisao}`).toLowerCase().includes(term)
                );
            },

            filteredGrupoServico() {
                const term = (this.filtroGrupoServico || '').toLowerCase();
                if (!term) return this.listaGrupoServico;

                return this.listaGrupoServico.filter(g =>
                    (`${g.codigoGrupo} - ${g.nomeGrupo}`).toLowerCase().includes(term)
                );
            },

            filteredClasseServico() {
                const term = (this.filtroClasseServico || '').toLowerCase();
                if (!term) return this.listaClasseServico;

                return this.listaClasseServico.filter(c =>
                    (`${c.codigoClasse} - ${c.nomeClasse}`).toLowerCase().includes(term)
                );
            },

            filteredSubclasseServico() {
                const term = (this.filtroSubclasseServico || '').toLowerCase();
                if (!term) return this.listaSubclasseServico;

                return this.listaSubclasseServico.filter(s =>
                    (`${s.codigoSubclasse} - ${s.nomeSubclasse}`).toLowerCase().includes(term)
                );
            }

        }

    };
</script>
<style lang="css" scoped>
    .exclusao-contador {
        font-size: 0.875rem;
        white-space: nowrap;
    }

    .modern-btn-danger {
        background: #dc3545;
        color: #fff;
    }

    .modern-btn-danger:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .modern-btn-secondary {
        background: #6c757d;
        color: #fff;
    }

    .selecao-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .selecao-checkbox {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .selecao-menu-toggle {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0 4px;
        color: inherit;
    }

    .selecao-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 20;
        min-width: 220px;
        display: flex;
        flex-direction: column;
        background: #fff;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .selecao-menu button {
        background: transparent;
        border: none;
        text-align: left;
        padding: 8px 12px;
        cursor: pointer;
        color: #212529;
        font-weight: normal;
    }

    .selecao-menu button:hover {
        background: #f1f3f5;
    }

    [data-bs-theme="dark"] .selecao-menu {
        background: #1f2937;
        border-color: #374151;
    }

    [data-bs-theme="dark"] .selecao-menu button {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .selecao-menu button:hover {
        background: #374151;
    }

    .btn-md {
        z-index: 1001;
    }

    .modern-modal {
        padding: 15px;
        padding-bottom: 15px;
    }

    .btn-outline-primary {
        min-height: 40px;
    }

    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(235, 232, 232, 0.25);
    }

    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 0 0 auto;
        text-align: left;
        max-width: 500px;
        min-width: 200px;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 20px 0;
        }

        .modern-header .container {
            padding-left: 16px;
            padding-right: 16px;
        }

        .header-content {
            flex-direction: column;
            text-align: left;
            gap: 16px;
            padding: 0;
        }

        .title-section {
            width: 100%;
            max-width: 100%;
            margin-left: 0;
        }

        .modern-title {
            font-size: 24px;
        }

        .modern-subtitle {
            font-size: 13px;
        }

        .table-container {
            padding-left: 8px;
            padding-right: 8px;
        }
    }

    /* Botões Modernos */
    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 42px;
        position: relative;
        overflow: hidden;
    }

        .modern-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .modern-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

        .modern-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
        }

        .modern-btn:active {
            transform: translateY(0);
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

        .modern-btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25);
    }

        .modern-btn-success:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            box-shadow: 0 8px 20px rgba(16, 185, 129, 0.35);
        }

    .modern-btn-signature {
        background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(139, 92, 246, 0.25);
    }

        .modern-btn-signature:hover {
            background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
            box-shadow: 0 8px 20px rgba(139, 92, 246, 0.35);
        }

    /* Search Box Moderna */
    .search-box {
        position: relative;
        flex: 1;
        min-width: 0;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
    }

        .modern-search-input:focus {
            outline: none;
            border-color: #2563eb;
            background: white;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }

    [data-bs-theme="dark"] .modern-search-input {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .modern-search-input:focus {
            background: #111827;
            border-color: #3b82f6;
        }

    [data-bs-theme="dark"] .modern-search-input::placeholder {
        color: #6b7280;
    }

    /* Botões de Ação na Tabela */
    .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

        .action-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .action-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

        .action-btn-view:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

    .action-btn-delete {
        background: transparent;
        color: #ef4444;
        border-color: #ef4444;
    }

    [data-bs-theme="dark"] .action-btn-delete {
        color: #f87171;
        border-color: #f87171;
    }

        .action-btn-delete::before {
            background: rgba(239, 68, 68, 0.1);
        }

        .action-btn-delete:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);
            border-color: #ef4444;
        }

    .action-btn:active {
        transform: translateY(0);
    }

    @media (max-width: 768px) {
        .action-text {
            display: none;
        }

        .action-btn {
            padding: 12px 16px;
            min-width: 48px;
            min-height: 48px;
            flex: 0 0 auto;
            justify-content: center;
            font-size: 14px;
        }

        .action-buttons {
            gap: 10px;
            flex-wrap: nowrap;
            justify-content: stretch;
            width: 100%;
        }
    }

    .th-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        min-height: 20px;
    }

    .th-title {
        text-align: center;
        font-weight: 700;
        letter-spacing: 0.3px;
    }

    .table-container {
        display: flex;
        justify-content: center;
        padding-top: 22px;
        padding-bottom: 0px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .table-wrapper {
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
        min-height: 700px;
    }

    @media (max-width: 768px) {
        .table-wrapper {
            overflow-x: visible;
            padding: 0;
        }
    }

    .custom-table {
        width: 100%;
        border: 1px solid #e5e7eb;
        border-radius: 0;
        box-shadow: none;
        border-collapse: collapse;
        background: white;
    }

        .custom-table th,
        .custom-table td {
            padding: 16px 20px;
            text-align: left;
            border-bottom: 1px solid #f3f4f6;
            transition: all 0.2s ease;
        }

        .custom-table td {
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 15px;
            color: #374151;
        }

        .custom-table th {
            font-weight: 700;
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

    [data-bs-theme="dark"] .custom-table {
        background: #1f2937;
        border-color: #374151;
    }

        [data-bs-theme="dark"] .custom-table th {
            background: #111827;
            color: #e5e7eb;
            border-bottom-color: #374151;
        }

        [data-bs-theme="dark"] .custom-table td {
            color: #e5e7eb;
            border-bottom-color: #374151;
        }

    .custom-table-footer {
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        font-family: 'Segoe UI';
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        flex-wrap: wrap;
        gap: 12px;
    }

    @media (max-width: 768px) {
        .custom-table-footer {
            flex-direction: column;
            align-items: stretch;
            padding: 16px;
            text-align: center;
        }

        .pagination-controls {
            justify-content: center;
            width: 100%;
        }
    }

    [data-bs-theme="dark"] .custom-table-footer {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .footer-records-text {
        font-size: 14px;
        font-weight: 600;
        color: #6b7280;
    }

    [data-bs-theme="dark"] .footer-records-text {
        color: #9ca3af;
    }

    .pagination-controls {
        display: flex;
        gap: 6px;
    }

    .custom-table-header {
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        border: 1px solid #e5e7eb;
        border-bottom: none;
        border-radius: 12px 12px 0 0;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        gap: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        flex-wrap: wrap;
    }

        .custom-table-header .modern-btn {
            flex-shrink: 0;
        }

    @media (max-width: 768px) {
        .custom-table-header {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            padding: 16px;
        }

        .custom-table-header .modern-btn {
            width: 100%;
            justify-content: center;
        }

        .search-box {
            width: 100%;
            order: -1;
        }
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        line-height: 1;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        background: white;
    }

        .page-box:hover {
            background-color: #f3f4f6;
            border-color: #2563eb;
            transform: translateY(-2px);
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
        }

        .page-box.disabled {
            opacity: 0.4;
            pointer-events: none;
            cursor: default;
        }

        .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: white;
            border-color: #2563eb;
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        }

    [data-bs-theme="dark"] .page-box {
        background-color: #1e293b;
        border: 2px solid #334155;
        color: #cbd5e1;
    }

        [data-bs-theme="dark"] .page-box:hover {
            background-color: #334155;
            border-color: #3b82f6;
        }

        [data-bs-theme="dark"] .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border: 2px solid #3b82f6;
        }

    .navigation-symbol {
        display: inline-block;
        line-height: 1;
        font-size: 18px;
        font-weight: 700;
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        animation: fadeIn 0.2s ease-out;
        padding: 20px;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .modal-content-custom {
        background: white;
        padding: 32px;
        border-radius: 16px;
        width: 100%;
        max-width: 700px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
        animation: slideUp 0.3s ease-out;
        max-height: 90vh;
        overflow-y: auto;
        position: relative;
    }

    [data-bs-theme="dark"] .modal-content-custom {
        background: #1f2937;
        border: 1px solid #374151;
    }

    [data-bs-theme="dark"] .btn-close-custom {
        background: rgba(15, 23, 42, 0.92);
        border-color: rgba(148, 163, 184, 0.25);
    }

        [data-bs-theme="dark"] .btn-close-custom svg {
            color: #e2e8f0;
        }

    .btn-close-custom {
        position: absolute;
        top: -12px;
        right: -12px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: #ffffff;
        border: 2px solid #e9ecef;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10;
    }

        .btn-close-custom:hover {
            transform: scale(1.1);
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
            border-color: #dc3545;
            box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
        }

            .btn-close-custom:hover svg {
                color: #ffffff;
            }

        .btn-close-custom svg {
            color: #6c757d;
            transition: all 0.3s ease;
        }

        .btn-close-custom:active {
            transform: scale(0.95);
        }

    .custom-table tbody tr {
        transition: all 0.2s ease;
    }

        .custom-table tbody tr:hover {
            background-color: #f9fafb;
            transform: scale(1.002);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background-color: #374151;
        color: white;
    }

    .separador {
        height: 2px;
        background: linear-gradient(to right, transparent, #e5e7eb 20%, #e5e7eb 80%, transparent);
        margin-top: 12px;
        margin-bottom: 20px;
    }

    [data-bs-theme="dark"] .separador {
        background: linear-gradient(to right, transparent, #374151 20%, #374151 80%, transparent);
    }

    .importacao-em-andamento-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: calc(100vh - 260px);
        padding: 28px 16px 40px;
    }

    .importacao-em-andamento-card {
        width: 100%;
        max-width: 760px;
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(226, 232, 240, 0.95);
        box-shadow: 0 16px 42px rgba(15, 23, 42, 0.08);
        padding: 32px 26px;
        text-align: center;
    }

    .importacao-em-andamento-icon {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin: 0 auto 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #ffffff;
        animation: pulseImportacao 1.8s ease-in-out infinite;
    }

    .importacao-em-andamento-card h2 {
        margin: 0 0 8px;
        font-size: 1.6rem;
        font-weight: 700;
        color: #0f172a;
    }

    .importacao-em-andamento-card p {
        margin: 0 auto;
        max-width: 620px;
        font-size: 1rem;
        color: #475569;
    }

    .importacao-em-andamento-actions {
        margin-top: 20px;
        margin-bottom: 8px;
        display: flex;
        justify-content: center;
    }

    .importacao-em-andamento-card small {
        display: block;
        margin-top: 2px;
        color: #64748b;
        font-size: 0.86rem;
    }

    @keyframes pulseImportacao {
        0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.35);
        }
        70% {
            transform: scale(1.03);
            box-shadow: 0 0 0 14px rgba(37, 99, 235, 0);
        }
        100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
        }
    }

    [data-bs-theme="dark"] .importacao-em-andamento-card {
        background: #0f172a;
        border-color: rgba(51, 65, 85, 0.95);
        box-shadow: 0 16px 42px rgba(2, 6, 23, 0.55);
    }

    [data-bs-theme="dark"] .importacao-em-andamento-card h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .importacao-em-andamento-card p {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .importacao-em-andamento-card small {
        color: #94a3b8;
    }

    /* Estado Vazio */
    .empty-state {
        padding: 80px 20px !important;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        animation: fadeInUp 0.5s ease-out;
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .empty-icon {
        color: #cbd5e1;
        margin-bottom: 8px;
    }

    .grid-spinner {
        width: 48px;
        height: 48px;
        margin-bottom: 8px;
        animation: grid-spinner-rotate 2s linear infinite;
    }

        .grid-spinner circle {
            stroke: #2563eb;
            stroke-linecap: round;
            animation: grid-spinner-dash 1.5s ease-in-out infinite;
        }

    @keyframes grid-spinner-rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes grid-spinner-dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }

        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }

        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }

    [data-bs-theme="dark"] .empty-icon {
        color: #475569;
    }

    [data-bs-theme="dark"] .grid-spinner circle {
        stroke: #60a5fa;
    }

    .empty-title {
        font-size: 24px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    .empty-description {
        font-size: 16px;
        color: #6b7280;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-description {
        color: #9ca3af;
    }

    @media (max-width: 768px) {
        .custom-table {
            min-width: 0;
            border: none;
            background: transparent;
        }

        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

        .custom-table thead {
            display: none;
        }

        .custom-table tbody {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .custom-table tr {
            margin-bottom: 0;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            overflow: hidden;
            border: 1px solid #e5e7eb;
            /*background: white;*/
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .custom-table td {
            text-align: left !important;
            padding: 12px 16px;
            position: relative;
            border: none;
            border-bottom: 1px solid #e5e7eb;
            display: flex;
            flex-direction: column;
            width: 100%;
            box-sizing: border-box;
            word-wrap: break-word;
            overflow-wrap: break-word;
        }

        .custom-table td::before {
            content: attr(data-label);
            font-weight: 600;
            display: block;
            margin-bottom: 8px;
            color: #6b7280;
            font-size: 13px;
        }

        .custom-table td:last-child {
            border-bottom: none;
        }

        .action-cell {
            white-space: normal !important;
            width: 100% !important;
            padding: 16px !important;
            box-sizing: border-box;
        }

        .action-cell::before {
            margin-bottom: 12px;
        }

        .action-cell .action-buttons {
            margin-top: 0;
            width: 100%;
            box-sizing: border-box;
        }

        [data-bs-theme="dark"] .custom-table tr {
            border-color: #374151;
        }

        [data-bs-theme="dark"] .custom-table td {
            border-bottom-color: #374151;
        }

        [data-bs-theme="dark"] .custom-table td::before {
            color: #9ca3af;
        }
    }

    /* Responsivo - Mobile Pequeno */
    @media (max-width: 576px) {
        .modern-header {
            padding: 16px 0;
        }

        .modern-header .container {
            padding-left: 12px;
            padding-right: 12px;
        }

        .modern-title {
            font-size: 20px;
        }

        .modern-subtitle {
            font-size: 12px;
        }

        .table-container {
            padding-left: 4px;
            padding-right: 4px;
        }

        .custom-table-header {
            padding: 12px;
        }

        .custom-table-footer {
            padding: 12px;
        }

        .custom-table tr {
            margin-bottom: 0;
            border-radius: 12px;
        }

        .custom-table td {
            padding: 12px 14px;
        }

        .action-cell {
            padding: 14px !important;
        }
    }

    /* Modal moderno */
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 22px;
        position: relative;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

        .modal-modern-header .header-icon {
            width: 60px;
            height: 60px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.16) 0%, rgba(16, 185, 129, 0.16) 100%);
            color: #2563eb;
            flex-shrink: 0;
        }

        .modal-modern-header .header-text {
            display: flex;
            flex-direction: column;
            gap: 6px;
        }

            .modal-modern-header .header-text h2 {
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: #0f172a;
            }

            .modal-modern-header .header-text p {
                margin: 0;
                font-size: 14px;
                color: #475569;
                max-width: 420px;
                line-height: 1.45;
            }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .intro-text {
        font-size: 14px;
        color: #475569;
        line-height: 1.5;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    .form-group-wrapper {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .form-field-group {
        display: flex;
        flex-direction: column;
    }

        .form-field-group.field-readonly .form-label {
            color: #9ca3af;
        }

        [data-bs-theme="dark"] .form-field-group.field-readonly .form-label {
            color: #64748b;
        }

    .form-row {
        display: flex;
        gap: 18px;
        width: 100%;
    }

        .form-row .form-field-group {
            flex: 1;
        }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, color 0.2s ease;
    }

        .modern-modal .form-control:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
        }

        .modern-modal .form-control:disabled,
        .modern-modal .form-control[readonly] {
            background-color: #e5e7eb !important;
            border-color: #d1d5db !important;
            color: #6b7280 !important;
            cursor: not-allowed;
            opacity: 1;
            box-shadow: none;
            -webkit-text-fill-color: #6b7280;
        }

    .modern-modal select.form-control {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

        .modern-modal select.form-control:disabled {
            background-color: #e5e7eb !important;
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%239CA3AF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            cursor: not-allowed;
        }

    .info-chip {
        display: inline-flex;
        align-items: flex-start;
        gap: 10px;
        padding: 14px 16px;
        border-radius: 12px;
        background: rgba(37, 99, 235, 0.08);
        color: #1e3a8a;
        font-size: 13px;
        line-height: 1.45;
    }

        .info-chip svg {
            flex-shrink: 0;
        }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-close-modern:hover {
            transform: scale(1.07);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
            border-color: transparent !important;
        }

            .btn-close-modern:hover svg {
                color: #ffffff;
            }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

            .modal-modern-header::after {
                left: 20px;
                right: 20px;
            }
    }

    @media (max-width: 576px) {
        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }

        .modal-modern-body {
            padding: 22px 18px;
        }

        .modal-modern-footer {
            padding: 0 18px 22px;
        }
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111827 100%);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.24) 0%, rgba(16, 185, 129, 0.24) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p,
    [data-bs-theme="dark"] .intro-text {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-modal .form-control:focus {
            background: rgba(15, 23, 42, 0.95);
            border-color: #3b82f6;
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.2);
        }

        [data-bs-theme="dark"] .modern-modal .form-control:disabled,
        [data-bs-theme="dark"] .modern-modal .form-control[readonly] {
            background-color: #334155 !important;
            border-color: #475569 !important;
            color: #94a3b8 !important;
            -webkit-text-fill-color: #94a3b8;
            cursor: not-allowed;
            opacity: 1;
            box-shadow: none;
        }

    [data-bs-theme="dark"] .modern-modal .form-control::placeholder {
        color: #64748b;
    }

    .modern-modal .form-select {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, color 0.2s ease;
    }

        .modern-modal .form-select:disabled {
            background-color: #e5e7eb !important;
            border-color: #d1d5db !important;
            color: #6b7280 !important;
            cursor: not-allowed;
            opacity: 1;
            box-shadow: none;
        }

    [data-bs-theme="dark"] .modern-modal .form-select {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-modal .form-select:focus {
            background: rgba(15, 23, 42, 0.95);
            border-color: #3b82f6;
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.2);
        }

        [data-bs-theme="dark"] .modern-modal .form-select:disabled {
            background-color: #334155 !important;
            border-color: #475569 !important;
            color: #94a3b8 !important;
            cursor: not-allowed;
            opacity: 1;
            box-shadow: none;
        }

    [data-bs-theme="dark"] .modern-modal .invalid-feedback {
        color: #fca5a5;
    }

    [data-bs-theme="dark"] .modern-modal .text-muted {
        color: #94a3b8 !important;
    }

    [data-bs-theme="dark"] .separator-line {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .info-chip {
        background: rgba(37, 99, 235, 0.18);
        color: #bfdbfe;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

        [data-bs-theme="dark"] .btn-close-modern svg {
            color: #e2e8f0;
        }

    /* Importação Styles */
    .import-section {
        padding: 0;
    }

    .separator-line {
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.3), transparent);
        margin: 0;
    }

    .modern-switch {
        padding: 14px 18px;
        background: rgba(37, 99, 235, 0.06);
        border-radius: 12px;
        border: 2px solid rgba(37, 99, 235, 0.1);
        transition: all 0.3s ease;
    }

        .modern-switch:hover {
            background: rgba(37, 99, 235, 0.1);
            border-color: rgba(37, 99, 235, 0.2);
        }

        .modern-switch .form-check-input {
            width: 3em;
            height: 1.5em;
            cursor: pointer;
            border: 2px solid #cbd5e1;
            background-color: #e2e8f0;
            transition: all 0.3s ease;
        }

            .modern-switch .form-check-input:checked {
                background-color: #2563eb;
                border-color: #2563eb;
            }

        .modern-switch .form-check-label {
            font-size: 14px;
            color: #1f2937;
            cursor: pointer;
            margin-left: 12px;
        }

    [data-bs-theme="dark"] .modern-switch {
        background: rgba(59, 130, 246, 0.12);
        border-color: rgba(59, 130, 246, 0.2);
    }

        [data-bs-theme="dark"] .modern-switch:hover {
            background: rgba(59, 130, 246, 0.18);
            border-color: rgba(59, 130, 246, 0.3);
        }

        [data-bs-theme="dark"] .modern-switch .form-check-label {
            color: #e2e8f0;
        }

    .origin-buttons {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
    }

    .origin-button {
        flex: 1;
        min-width: 200px;
        cursor: pointer;
    }

        .origin-button .button-content {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px 24px;
            background: #f8fafc;
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            transition: all 0.3s ease;
            font-size: 14px;
            font-weight: 600;
            color: #475569;
            text-align: center;
        }

        .origin-button:hover:not(.disabled) .button-content {
            border-color: #2563eb;
            background: #ffffff;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
            color: #2563eb;
        }

        .origin-button.active .button-content {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            border-color: #2563eb;
            color: #ffffff;
            box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3);
        }

        .origin-button.disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

            .origin-button.disabled .button-content {
                background: #f3f4f6;
                cursor: not-allowed;
            }

    .button-title {
        display: block;
    }

    [data-bs-theme="dark"] .origin-button .button-content {
        background: rgba(15, 23, 42, 0.6);
        border-color: rgba(148, 163, 184, 0.25);
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .origin-button:hover:not(.disabled) .button-content {
        border-color: #3b82f6;
        background: rgba(15, 23, 42, 0.9);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .origin-button.active .button-content {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        border-color: #3b82f6;
        color: #ffffff;
    }

    [data-bs-theme="dark"] .origin-button.disabled .button-content {
        background: rgba(30, 41, 59, 0.5);
    }

    .filter-section {
        margin-top: 8px;
        padding: 20px;
        background: linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%);
        border: 2px solid #e5e7eb;
        border-radius: 16px;
        transition: all 0.3s ease;
    }

        .filter-section:hover {
            border-color: #2563eb;
            box-shadow: 0 4px 16px rgba(37, 99, 235, 0.1);
        }

    .filter-header {
        margin-bottom: 20px;
        padding-bottom: 16px;
        border-bottom: 2px solid rgba(37, 99, 235, 0.1);
    }

        .filter-header h5 {
            margin: 0;
            font-size: 16px;
            font-weight: 700;
            color: #1f2937;
            letter-spacing: 0.3px;
        }

    .filter-content {
        padding: 0;
    }

    [data-bs-theme="dark"] .filter-section {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.8) 0%, rgba(30, 41, 59, 0.9) 100%);
        border-color: rgba(148, 163, 184, 0.25);
    }

        [data-bs-theme="dark"] .filter-section:hover {
            border-color: #3b82f6;
            box-shadow: 0 4px 16px rgba(59, 130, 246, 0.2);
        }

    [data-bs-theme="dark"] .filter-header {
        border-bottom-color: rgba(59, 130, 246, 0.2);
    }

        [data-bs-theme="dark"] .filter-header h5 {
            color: #f8fafc;
        }

    .info-tip {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px 20px;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(37, 99, 235, 0.04) 100%);
        border-left: 4px solid #2563eb;
        border-radius: 12px;
        margin-top: 8px;
    }

    .tip-icon {
        color: #2563eb;
        flex-shrink: 0;
        margin-top: 2px;
    }

    .info-tip span {
        font-size: 13px;
        line-height: 1.6;
        color: #475569;
    }

    .info-tip strong {
        color: #1e40af;
    }

    [data-bs-theme="dark"] .info-tip {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(59, 130, 246, 0.08) 100%);
        border-left-color: #3b82f6;
    }

    [data-bs-theme="dark"] .tip-icon {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .info-tip span {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .info-tip strong {
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .modern-modal .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

    /* Vue Select Custom Styles */
    .modal-modern-body :deep(.v-select) {
        width: 100%;
        font-size: 15px;
    }

    .modal-modern-body :deep(.v-select .vs__dropdown-toggle) {
        border: 2px solid rgba(148, 163, 184, 0.25);
        border-radius: 12px;
        padding: 14px 18px;
        background: #ffffff;
        transition: all 0.2s ease;
        min-height: 52px;
    }

    .modal-modern-body :deep(.v-select .vs__selected-options) {
        padding: 0;
    }

    .modal-modern-body :deep(.v-select .vs__search) {
        font-size: 15px;
        padding: 0;
        margin: 0;
        line-height: 1.5;
    }

    .modal-modern-body :deep(.v-select .vs__selected) {
        font-size: 15px;
        line-height: 1.5;
        margin: 0;
        padding: 0;
    }

    .modal-modern-body :deep(.v-select .vs__actions) {
        padding: 0 0 0 8px;
    }

    .modal-modern-body :deep(.v-select .vs__clear) {
        padding: 4px;
    }

    .modal-modern-body :deep(.v-select .vs__open-indicator) {
        width: 20px;
        height: 20px;
    }

    .modal-modern-body :deep(.v-select .vs__dropdown-menu) {
        font-size: 15px;
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        margin-top: 4px;
    }

    .modal-modern-body :deep(.v-select .vs__dropdown-option) {
        padding: 14px 18px;
        line-height: 1.6;
        font-size: 15px;
    }

    .modal-modern-body :deep(.v-select .vs__dropdown-option--highlight) {
        background: rgba(37, 99, 235, 0.1);
        color: #2563eb;
    }

    .modal-modern-body :deep(.v-select.vs--open .vs__dropdown-toggle) {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__search) {
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__search::placeholder) {
            color: #64748b;
        }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__no-options) {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-toggle) {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-menu) {
        background: rgba(15, 23, 42, 0.98);
        border-color: rgba(148, 163, 184, 0.25);
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-option) {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-option--highlight) {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select.vs--open .vs__dropdown-toggle) {
        border-color: #3b82f6;
        background: rgba(15, 23, 42, 0.95);
    }

    @media (max-width: 768px) {
        .form-row {
            flex-direction: column;
            gap: 0;
        }

        .origin-buttons {
            flex-direction: column;
        }

        .origin-button {
            min-width: 100%;
        }
    }
</style>

